var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { PaginationMetaData, Transaction } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
import { useNavigate } from 'react-router';
var TransactionSevice = /** @class */ (function (_super) {
    __extends(TransactionSevice, _super);
    function TransactionSevice() {
        var _this = _super.call(this) || this;
        _this.transactionsRoot = 'transactions';
        _this.successMessage = '';
        return _this;
    }
    TransactionSevice.prototype.useTransactions = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.accounting.transactions, pageNumber, filters], function () {
            return _this.get(_this.transactionsRoot, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var transactions = plainToInstance(Transaction, data === null || data === void 0 ? void 0 : data.transactions);
                var meta = plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { transactions: transactions, meta: meta };
            }
        });
    };
    TransactionSevice.prototype.fetchTransactionsPage = function () {
        return __awaiter(this, arguments, void 0, function (pageNumber, filters) {
            var data;
            if (pageNumber === void 0) { pageNumber = 1; }
            if (filters === void 0) { filters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(this.transactionsRoot, __assign(__assign({}, filters), { page: pageNumber }))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, {
                                transactions: plainToInstance(Transaction, ((data === null || data === void 0 ? void 0 : data.transactions) || [])),
                                meta: plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta)
                            }];
                }
            });
        });
    };
    TransactionSevice.prototype.useGetTransaction = function (id) {
        var _this = this;
        return useQuery(['show', queries.accounting.transactions, id], function () {
            return _this.get("".concat(_this.transactionsRoot, "/").concat(id));
        }, {
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Transaction, data);
            }
        });
    };
    TransactionSevice.prototype.useCreateTransaction = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        return useMutation(function (_a) {
            var transaction = _a.transaction, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { transaction: instanceToPlain(transaction) };
            return _this.post(_this.transactionsRoot, { data: data });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.refetchQueries({ queryKey: [queries.accounting.transactions] });
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate('/transactions');
            }
        });
    };
    TransactionSevice.prototype.useCreatePatientTransaction = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var patientId = null;
        return useMutation(function (_a) {
            var transaction = _a.transaction, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { transaction: instanceToPlain(transaction) };
            patientId = transaction.getEntityId();
            return _this.post("".concat(_this.transactionsRoot, "/create_patient_transaction"), { data: data });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.refetchQueries({ queryKey: [queries.accounting.transactions] });
                queryClient.refetchQueries({ queryKey: [queries.patient, patientId] });
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    TransactionSevice.prototype.useRevertTransaction = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        var currentTransaction = null;
        return useMutation(function (_a) {
            var transaction = _a.transaction, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            currentTransaction = transaction;
            return _this.put("".concat(_this.transactionsRoot, "/").concat(transaction.getId(), "/revert"));
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.refetchQueries({ queryKey: ['show', queries.accounting.transactions, currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.getId()] });
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate("/transactions/".concat(currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.getId()));
            }
        });
    };
    TransactionSevice.prototype.useRefundTransaction = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        var currentTransaction = null;
        return useMutation(function (_a) {
            var transaction = _a.transaction, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            currentTransaction = transaction;
            return _this.put("".concat(_this.transactionsRoot, "/").concat(transaction.getId(), "/refund"));
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.refetchQueries({ queryKey: ['show', queries.accounting.transactions, currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.getId()] });
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate("/transactions/".concat(currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.getId()));
            }
        });
    };
    TransactionSevice.getInstance = function () {
        if (!TransactionSevice.transactionSevice) {
            TransactionSevice.transactionSevice = new TransactionSevice();
        }
        return TransactionSevice.transactionSevice;
    };
    return TransactionSevice;
}(ApiService));
export default TransactionSevice;
